import { ErrorHandler, inject, Injectable, isDevMode } from '@angular/core';
import { generateErrorId } from '../shared/utils/unique-id-utils';
import { ClientLoggingService } from './services/client-logging.service';
import { ApplicationStore, ApplicationStoreType } from './store/application.store';
import { Toast } from '../shared/types/toast';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class GlobalErrorHandler implements ErrorHandler {
    private loggingService = inject(ClientLoggingService);
    private applicationStore: ApplicationStoreType = inject(ApplicationStore);

    public handleError(error: any): void {
        if (!environment.production) {
            console.log(error);
        }

        const correlationId = generateErrorId();
        this.loggingService.log(correlationId, error);
        this.applicationStore.addToast(
            new Toast(correlationId, [
                `An error occurred, please refresh the page and try again`,
                `Correlation Id: ${correlationId}`,
            ]),
        );
    }
}
